import { CatalogTypePage } from './CatalogTypePage';
import { CatalogPanelFormPage } from './CatalogPanelFormPage';

const SHARED = {
  type: 'PANEL' as const,
  i18nNs: 'panels',
  listTo: '/panels' as const,
  newTo: '/panels/new' as const,
  editToParent: '/panels/$id' as const,
  editParentRouteId: '/protected/panels/$id' as const,
};

export function PanelsListPage() {
  return (
    <CatalogTypePage
      type={SHARED.type}
      i18nNs={SHARED.i18nNs}
      listTo={SHARED.listTo}
      newTo={SHARED.newTo}
      editToParent={SHARED.editToParent}
    />
  );
}

export function PanelCreatePage() {
  return <CatalogPanelFormPage mode="create" />;
}

export function PanelEditPage() {
  return <CatalogPanelFormPage mode="edit" />;
}
